// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"L8cZ3","effectsGrayscale30":"_3NbiX","resetList":"Tk1ic","onboardingContainer":"RVuKH","headline":"_18n4_","video":"_2Wuoj","isDesktop":"_3Uz4Q"};